
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <ol>
      <li>Erkennen und meiden Sie Ihre persönlichen Migräneauslöser. Beim Ausfindigmachen Ihrer individuellen Auslöser können Ihnen ein «Kopfschmerztagebuch» und eine Triggerfaktoren-Checkliste helfen. Füllen Sie sie regelmässig aus!
      </li>
      <li>Behalten Sie einen gleichmässigen Schlaf- und Wachrhythmus bei – vor allem am Wochenende. Deshalb am Wochenende Wecker auf die gewohnte Weckzeit einstellen und zur gleichen Zeit frühstücken wie sonst auch. Das ist zwar hart, kann aber am Wochenende vor Migräne schützen. Nach dem Frühstück können Sie sich gerne wieder ins Bett legen.</li>
      <li>Achten Sie auf sehr regelmässige Essenszeiten.</li>
      <li>Treiben Sie regelmässig Ausdauersport – zum Beispiel Schwimmen, Radfahren, Wandern. Das hilft Ihnen und Ihrem Gehirn zu «entspannen».</li>
      <li>Versuchen Sie eine besonders ausgeglichene Lebensführung. Ein sehr gleichmässiger Tagesablauf kann Kopfschmerzen verhindern.</li>
      <li>Lernen Sie, «Nein» zu sagen. Lassen Sie sich nicht zu Dingen drängen, die den von Ihnen vorgegebenen gleichmässigen Rhythmus ausser Takt bringen. Es kommt schliesslich auf Sie an!</li>
      <li>Lernen Sie das Entspannungstraining «Progressive Muskelrelaxation nach Jacobson». Auf <Link href='https://youtu.be/JlbQUjJzO6o' mdxType="Link">Youtube</Link> findet man dazu Anleitungen, es gibt auch CDs im Buchhandel. Üben Sie regelmässig.</li>
      <li>Werden Sie gelassener, und entwickeln Sie eine grössere Distanz zu den scheinbar unabänderlichen Dingen des Alltags. Sie können sich zwar über alles ärgern, Sie sind jedoch nicht dazu verpflichtet. Gut geplante, regelmässige Pausen sind der Geheimtipp für einen produktiven Tag.</li>
      <li>Beachten Sie die Einnahmeregeln für Ihre Medikamente. Vorbeugende Medikamente müssen regelmässig über mehrere Monate verwendet werden, sie wirken meist erst nach mehreren Wochen. Nehmen Sie Medikamente zur Behandlung der akuten Attacke ein, sobald Sie eine Migräneattacke erkennen. Verwenden Sie die Triptanschwelle zur Identifikation des besten Zeitpunktes.</li>
      <li>Verwenden Sie Akutmedikation maximal an 10 Tagen pro Monat. Verwenden Sie keine Akutmedikation, die nicht zuverlässig bei Ihnen wirkt. Mässig wirksame Medikamente, die oft benötigt werden, können die Attackenhäufigkeit erhöhen. Lassen Sie sich ein wirksames Medikament verordnen, das zuverlässig wirkt.</li>
    </ol>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;